module.exports = __webpack_public_path__ + "img/movie-roll.dd61b9e2.svg";